// extracted by mini-css-extract-plugin
export default {"downContainer":"ServerDown_downContainer__6KawK"};